import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import Unlock from '@/plugins/graphql/mutations/v2/auth/unlock-account.gql';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import { required } from 'vuelidate/lib/validators';
import VueRecaptcha from 'vue-recaptcha';
import RecaptchaMixin from '@/helpers/mixins/RecaptchaMixin';
let UnlockAccount = class UnlockAccount extends Mixins(ViewportSizeMixin, FormValidationsMixin, RecaptchaMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            birthdate: null,
        };
    }
    async unlockAccount() {
        this.$v.$touch();
        if (this.isRobot) {
            this.recaptchaErrorNotifier();
            return;
        }
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            const { birthdate } = this.form;
            const token = this.$route.params.unlockToken;
            return this.$apollo
                .mutate({
                mutation: Unlock,
                variables: {
                    input: {
                        birthdate,
                        token,
                    },
                },
            })
                .then((result) => {
                const data = result.data.unlockAccount;
                this.successNotification(data.message);
                this.requestDone();
                this.$router.push(`/reset-password/${data.resetPasswordToken}`);
            })
                .catch((e) => {
                this.recaptchaErrorNotifier(e.message);
            });
        }
    }
};
UnlockAccount = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
            BaseDatePicker,
            VueRecaptcha,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = false;
                return true;
            });
        },
        validations: {
            form: {
                birthdate: {
                    required,
                },
            },
        },
    })
], UnlockAccount);
export default UnlockAccount;
